import { DynamicFormDefinition } from "./dynamic-form-definition";

export interface FormSubmission extends EntityBase {
    createdOn?: Date;
    formSubmissionData: any;
    formDefinitionId: string;
    clientId: string;
    recaptchaToken?: string;
    isViewed: boolean;
}

export interface Provider extends EntityBase {
    firstName: string;
    lastName: string;
    externalId: string;
    clientId: string;
}

export interface Patient extends EntityBase {
    firstName: string;
    lastName: string;
    dateOfBirth: Date | string;
    gender: string;
    externalId?: string;
    clientId?: string;
}

export interface EntityBase {
    id: string | null;
}

export interface Client {
    id: string;
    name: string;
    parentId: string;
}

export interface FormStatsResponse {
    submissionCountTotal: number;
    viewCountTotal: number;

    submissionCountLast7: number;
    viewCountLast7: number;
}

export interface FormSubmissionsListResponse {
    submissions: FormSubmission[]
}

export interface Schedule extends EntityBase {
    patientFirstName: string;
    patientLastName: string;
    patientExternalId: string;
    providerFirstName: string;
    providerLastName: string;
    providerExternalId: string;
    patientBirthDate: string;
    patientAddress: string;
    patientPhone1: string;
    patientPhone2: string;
    startDate: string;
    startTime: string;
    endTime: string;
    program: string;
    location: string;
    documents: string[];
}

export interface FormDefinitionsGetRequest {
    onlyOfflineForms: boolean;
    clientId: string | null;
}

export interface User {
    id: string | null;
    username: string;
    clientId: string | null;
    roles: string[];
}

export class Roles {
    public static readonly FormsAdmin: string = "FormsAdmin";
    public static readonly FormSubmissionViewer: string = "FormSubmissionViewer";
    public static readonly UserAdmin: string = "UserAdmin";
    public static readonly OfflineUser: string = "OfflineUser";
    public static readonly WelcomeBoard: string = "WelcomeBoard";
}

export interface FormDefinitionPostRequest {
    formDefinition: DynamicFormDefinition;
    clientId: string | undefined;
}

export interface SetSubmissionViewedRequest {
    isViewed: boolean;
    submissionId: string;
}

export interface WelcomeBoard extends EntityBase {
    clientId: string;
    facebookUrl: string;
    instagramUrl: string;
    reviewUrl: string;
    cssOverride: string;
    staff: WelcomeBoardStaff[];
    iceBreakers: WelcomeBoardIceBreaker[];
    hygieneServiceTypes: string[];
    logoImage: string;
    backgroundImage: string;
    practiceName: string;
    services: WelcomeBoardService[];
    mainLayoutId: string;
    emptyLayoutId: string;
}

export interface WelcomeBoardStaff {
    staffId?: string;
    staffName?: string;
    portraitImage?: string;
    portraitImageBase64Data?: string;
}

export interface WelcomeBoardIceBreaker {
    title?: string;
    body?: string;
}

export interface WelcomeBoardService {
    htmlContent?: string
    videoFile?: string
    imageFile?: string
    title?: string
    isEnabled?: boolean;
    selectedContentType?: WelcomeBoardContentType;
}

export type WelcomeBoardContentType = 'html' | 'image' | 'video';

export enum WelcomeBoardWidgetType {
    None = 0,
    DateAndTime = 1,
    AppointmentInfo = 2,
    Image = 3,
    PatientGreeting = 4,
    ProviderInfo = 5,
    QrCode = 6,
    ServicesRotator = 7,
    SocialMedia = 8
}

export interface WelcomeBoardItem {
    type: WelcomeBoardWidgetType;
    gridColumn?: string;
    gridRow?: string;
    content?: string;
    css?: string;
}

export interface WelcomeBoardLayout extends EntityBase {
    clientId: string;
    name: string;
    gridColumnsTemplate: string;
    gridRowsTemplate: string;
    welcomeBoardItems: WelcomeBoardItem[];
}

export interface StorageItem {
    path: string;
}